"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _flat = _interopRequireDefault(require("flat"));

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable func-names */

/**
 * @NOTE
 * Class inheritance was not working in production envs
 * Prototypes seem to register more consistently.
 */


URLSearchParams.prototype.populate = function () {
  var _this = this;

  var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.entries(a).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return Object.assign(acc, _defineProperty({}, key, Array.isArray(value) ? _this.getAll("".concat(key, "[]")) : _this.get(key) || value));
  }, {});
};

URLSearchParams.prototype.serializeAndAssign = function (key, v) {
  var arr = (0, _utils.serializeArray)(v);

  if (arr.length) {
    this.set((0, _utils.asInverted)(key, arr), (0, _utils.asEmpty)(arr));
  } else {
    this.delete(key);
  }
};

URLSearchParams.prototype.merge = function (a) {
  var _this2 = this;

  Object.entries(a).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        v = _ref4[1];

    if ((0, _utils.isEmpty)(v)) {
      _this2.delete(key);
    } else if (Array.isArray(v)) {
      _this2.serializeAndAssign(key, v);
    } else if (typeof v === 'object') {
      Object.entries((0, _flat.default)(v, {
        safe: true
      })).forEach(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            name = _ref6[0],
            value = _ref6[1];

        _this2.serializeAndAssign("".concat(key, ".").concat(name), value);
      });
    } else {
      _this2.set((0, _utils.asInverted)(key, v), (0, _utils.asEmpty)(v));
    }
  });
};

URLSearchParams.prototype.redirectStr = function () {
  var str = this.toString();
  return str ? "?".concat(str) : '?';
};

var _default = URLSearchParams;
exports.default = _default;